<template>
  <div class="container mt-4">
    <div @click="navigateToAccountView()" style="cursor: pointer;">
      <b-icon icon="chevron-left"></b-icon>&nbsp;Zurück
    </div>

    <b-card class="mt-4">
      <h1 class="mb-4 text-center">Passwort ändern</h1>
      <b-form @submit.prevent="handlePasswordChange()">
        <b-form-group id="input-group-password" label-for="input-password">
          <b-form-input
            id="input-password"
            v-model="password"
            type="password"
            placeholder="Neues Passwort"
            required
          ></b-form-input>
        </b-form-group>

        <b-form-group
          id="input-group-repeat-password"
          label-for="input-repeat-password"
          class="mt-2"
        >
          <b-form-input
            id="input-repeat-password"
            v-model="repeatPassword"
            type="password"
            placeholder="Neues Passwort wiederholen"
            required
          ></b-form-input>
        </b-form-group>

        <b-button
          type="submit"
          variant="primary"
          class="mt-3"
          style="width: 100%; background-color: #b02a2a; border-color: #b02a2a"
          >Passwort ändern</b-button
        >
      </b-form>
    </b-card>
  </div>
</template>

<script>
import axios from "axios";
import { logout } from "@/services/auth";

export default {
  name: "accountSecurityView",
  components: {},
  data() {
    return {
      password: null,
      repeatPassword: null,

      apiUrl: process.env.VUE_APP_API_URL,
    };
  },

  methods: {
    handlePasswordChange() {
      const passwordPattern = /^.{6,}$/;

      const Toast = this.$swal.mixin({
        toast: true,
        position: "top",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });

      if (
        !passwordPattern.test(this.password) ||
        !passwordPattern.test(this.repeatPassword)
      ) {
        Toast.fire({
          icon: "error",
          title: "Passwort muss mindestens 6 Zeichen lang sein",
        });

        return;
      }

      if (this.password !== this.repeatPassword) {
        Toast.fire({
          icon: "error",
          title: "Passwörter stimmen nicht überein",
        });

        return;
      }

      const body = {
        password: this.password,
      };

      axios
        .post(this.apiUrl + "/account/security/change-password", body)
        .then(async (response) => {
          Toast.fire({
            icon: "success",
            title: "Passwort geändert",
            text: "Du wirst jetzt ausgeloggt...",
          });
          await logout();
          this.$router.push("/login");
          return response.data;
        });
    },

    navigateToAccountView() {
      this.$router.push(`/account`);
    },
  },

  beforeMount() {},
};
</script>

<style scoped></style>
